// Bayi sözleşme ve belge onayları — admin modelleri.
// Backend PascalCase döner (Startup.cs -> PropertyNamingPolicy = null).

export enum DealerContractStatus {
  Beklemede = 0,
  IncelemeBekliyor = 1,
  Onaylandi = 2,
  Reddedildi = 3,
  DuzeltmeIncelemeBekliyor = 4,
}

export enum DealerType {
  All = 'Tümü',
  Vodafone = 'Vodafone',
  Normal = 'Normal'
}

export enum DealerContractRejectScope {
  Belge = 1,
  Bilgi = 2,
  BelgeVeBilgi = 3,
}

export enum DealerContractLogAction {
  BilgiGirildi = 1,
  BilgiGuncellendi = 2,
  SozlesmeOlusturuldu = 3,
  SozlesmeOnaylandi = 4,
  BelgeYuklendi = 5,
  AdminOnayladi = 6,
  AdminReddetti = 7,
}

export interface IDealerContractFilter {
  Status?: number
  /** Baştaki sıfırlar girilmek zorunda değil; backend 10 haneye tamamlıyor. */
  SapCode?: string
  StartDate?: string
  EndDate?: string
  /** Yalnızca Vodafone carileri (kodu 7 ile başlayanlar). */
  DealerType?: string
}

export interface IDealerContractListItem {
  Id: number
  DealerSapCode: string
  CompanyName: string
  AuthorizedNameSurname: string
  Email: string
  MobilePhone: string
  Status: DealerContractStatus
  StatusText: string
  IsContractConfirmation: boolean
  ContractConfirmDate?: string | null
  DocumentsUploadDate?: string | null
  RejectScope?: DealerContractRejectScope | null
  RejectReason?: string | null
  RejectDate?: string | null
  ApprovedDate?: string | null
  DocumentCount: number
  /** Bayi şu anda bilgilerini güncelliyor; onaylanmamalı. */
  IsDealerEditing: boolean
  DealerEditingWhen?: string | null
  LogWhen: string
  /** Son hareket zamanı; liste bu alana göre azalan sıralı gelir. */
  LastActionWhen: string
}

export interface IDealerContractDealerInfo {
  DealerSapCode: string
  CompanyName: string
  Address: string
  TaxOrTcNumber: string
  TaxAdministration: string
  Email: string
  MobilePhone: string
}

export interface IDealerContractInfo {
  AuthorizedNameSurname: string
  AuthorizedTc: string
  MersisNo: string
  HasNoMersis: boolean
  Email: string
  MobilePhone: string
  CommercialMessage: boolean
  KvkkApproval: boolean
}

export interface IDealerContractDocument {
  Name: string
  FileName: string
  FileUrl: string
}

export interface IDealerContractFieldChange {
  Field: string
  Old: string
  New: string
}

export interface IDealerContractLog {
  Id: number
  Action: DealerContractLogAction
  ActionText: string
  Scope?: DealerContractRejectScope | null
  ScopeText?: string | null
  Message?: string | null
  /** Bayinin yaptığı bilgi değişiklikleri: eski → yeni. */
  Changes: IDealerContractFieldChange[]
  Documents: IDealerContractDocument[]
  ContractFileUrl?: string | null
  UserId?: number | null
  UserName?: string | null
  IsAdmin: boolean
  ClientIp?: string | null
  LogWhen: string
}

export interface IDealerContractDetail {
  Header: IDealerContractListItem
  Dealer: IDealerContractDealerInfo
  Info: IDealerContractInfo
  Documents: IDealerContractDocument[]
  ContractFileUrl?: string | null
  ContractVersion?: string | null
  ContractConfirmIp?: string | null
  History: IDealerContractLog[]
}

export interface IDealerContractRejectRequest {
  Scope: DealerContractRejectScope
  Reason: string
}
